import Vue from 'vue'
import VueI18n from 'vue-i18n'
import store from '../store'

Vue.use(VueI18n)

const i18n = new VueI18n({
  locale: store.state.locale,
  messages: {
    'en': {
      'back_to_top': 'Back to top',
      'top': 'Top',
      'menu_settings': 'Settings',
      'language': 'Language',
      'settings': 'Settings',
      'icon': 'Icon',
      'user_account': 'User  account',
      'log_out': 'Log out',
      'design_system_version': 'v0.0.57',
      'your_platforms': 'Your Platforms',
      'your_apps': 'Your Apps',
      'also_from_xx': 'Also from {0}',
      'Conicle': 'Conicle',
      'Explore the universe of learning': 'Explore the universe of learning',
      'all_apps': 'All Apps',
      'something_went_wrong': 'Something went wrong',
      'error_occurred_please_contact_the_admin_for_assistance': 'An error occurred. Please contact the admin for assistance.',
      'ok': 'OK',
      'previous': 'Previous',
      'next': 'Next'
    },
    'th': {
      'back_to_top': 'กลับสู่ข้างบน',
      'top': 'บน',
      'menu_settings': 'การตั้งค่า',
      'language': 'ภาษา',
      'settings': 'การตั้งค่า',
      'icon': 'ไอคอน',
      'user_account': 'บัญชีผู้ใช้',
      'log_out': 'ออกจากระบบ',
      'design_system_version': 'เวอร์ชัน 0.0.57',
      'your_platforms': 'แพลตฟอร์มของคุณ',
      'your_apps': 'แอปของคุณ',
      'also_from_xx': 'จาก {0} เช่นกัน',
      'Conicle': 'Conicle',
      'Explore the universe of learning': 'สำรวจจักรวาลแห่งการเรียนรู้',
      'all_apps': 'แอปทั้งหมด',
      'something_went_wrong': 'มีบางอย่างผิดพลาด',
      'error_occurred_please_contact_the_admin_for_assistance': 'โปรดติดต่อผู้ดูแลระบบเพื่อขอความช่วยเหลือ',
      'ok': 'ตกลง',
      'previous': 'ก่อนหน้า',
      'next': 'ถัดไป'
    }
  }
})

export default i18n
